import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#07382f] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img
              src="/assets/img/brand/logo-light.png"
              alt="Trademark Facility"
              className="h-10 sm:h-12 w-auto object-contain mb-4"
              data-testid="footer-logo"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Trademark registration, copyright protection, patent filing, and
              business formation — handled by experienced IP attorneys.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-bold text-lime uppercase tracking-[0.2em] mb-5">
              Navigate
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/resources/blogs"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold text-lime uppercase tracking-[0.2em] mb-5">
              Services
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/services/trademark/register"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Trademark Registration
                </Link>
              </li>
              <li>
                <Link
                  to="/services/copyright/register"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Copyright Protection
                </Link>
              </li>
              <li>
                <Link
                  to="/services/patent/application"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Patent Filing
                </Link>
              </li>
              <li>
                <Link
                  to="/services/company/llc"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  LLC Formation
                </Link>
              </li>
              <li>
                <Link
                  to="/services/legal/immigration"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Legal Advisory
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold text-lime uppercase tracking-[0.2em] mb-5">
              Contact
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-300 text-sm">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
                <span>340 E Middlefield Rd, Mountain View, CA 94043</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300 text-sm">
                <Phone className="h-4 w-4 shrink-0" />
                <span>+1 (877) 405-0574</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300 text-sm">
                <Mail className="h-4 w-4 shrink-0" />
                <span>info@trademarkfacility.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Trademark Facility. All rights
            reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-gray-400">
            <Link
              to="/privacy-policy"
              className="hover:text-white transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-and-conditions"
              className="hover:text-white transition-colors duration-200"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
